/**
 * Utilidades para ler parâmetros de configuração (um registro por empresa).
 */

/**
 * Resolve o registro efetivo de um parâmetro a partir da resposta da API.
 *
 * O endpoint de parâmetro devolve uma lista, e as telas pegavam sempre `resp.data[0]`. A
 * ordem dessa lista não é garantida pelo banco, então, se a empresa tiver mais de um
 * registro (dado inconsistente que o backend registra no log como "Identificado mais de um
 * registro para o findOne"), telas diferentes podiam ler configurações diferentes: a tela de
 * configurações mostrava a opção ligada enquanto a tela de operação lia o registro antigo,
 * com ela desligada.
 *
 * Escolher sempre o menor id torna a leitura determinística e igual em todas as telas.
 *
 * @param {object|Array} payload corpo da resposta (lista ou objeto único)
 * @returns {object|null} o registro escolhido, ou null quando não há nenhum
 */
export const resolveSingleParameter = (payload) => {
    const rows = Array.isArray(payload) ? payload : (payload ? [payload] : []);

    if (rows.length === 0) {
        return null;
    }

    return rows.reduce((chosen, current) => {
        if (!chosen) {
            return current;
        }

        // Registro sem id não deve vencer um com id: sem ele não há critério estável.
        if (current?.id == null) {
            return chosen;
        }

        if (chosen?.id == null) {
            return current;
        }

        return current.id < chosen.id ? current : chosen;
    }, null);
};
